import { useEffect } from 'react';
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import { Link } from 'react-router-dom';

const ElPaso = () => {
  useEffect(() => {
    // Set document title
    document.title = 'We Buy Valves El Paso | Industrial Equipment Buyers El Paso Texas';
    
    // Set meta tags
    const metaTags = [
      { name: 'description', content: 'We buy valves El Paso Texas - Leading valve buyers in El Paso serving West Texas and New Mexico. We purchase surplus valves, control systems, and instrumentation from El Paso refineries and manufacturing plants. Call 214-854-5638.' },
      { name: 'keywords', content: 'valve buyers El Paso, West Texas equipment, surplus valves, Fisher control valves, manufacturing equipment buyers' },
      { property: 'og:title', content: 'We Buy Valves El Paso | Industrial Equipment Buyers El Paso Texas' },
      { property: 'og:description', content: 'We buy valves El Paso Texas - Leading valve buyers in El Paso serving West Texas and New Mexico industrial facilities. Professional equipment purchasing services.' },
      { property: 'og:url', content: 'https://valvesalessupply.com/el-paso' },
      { property: 'og:type', content: 'website' },
      { name: 'geo.position', content: '31.7619;-106.4850' },
      { name: 'geo.placename', content: 'El Paso, Texas' },
      { name: 'geo.region', content: 'US-TX' }
    ];

    // Add or update meta tags
    metaTags.forEach(({ name, property, content }) => {
      const attribute = name ? 'name' : 'property';
      const value = name || property;
      let meta = document.querySelector(`meta[${attribute}="${value}"]`);
      
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute(attribute, value);
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', content);
    });

    // Set canonical link
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', 'https://valvesalessupply.com/el-paso');

    // Add schema.org structured data
    const schemaData = {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "WebPage",
          "@id": "https://valvesalessupply.com/el-paso",
          "url": "https://valvesalessupply.com/el-paso",
          "name": "El Paso Valve Buyers Texas | West Texas Equipment",
          "description": "Leading valve buyers in El Paso serving West Texas and New Mexico. We purchase surplus valves, control systems, and instrumentation from El Paso refineries and manufacturing plants. Call 214-854-5638.",
          "breadcrumb": {
            "@type": "BreadcrumbList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "Home",
                "item": "https://valvesalessupply.com"
              },
              {
                "@type": "ListItem",
                "position": 2,
                "name": "Texas",
                "item": "https://valvesalessupply.com/texas"
              },
              {
                "@type": "ListItem",
                "position": 3,
                "name": "El Paso",
                "item": "https://valvesalessupply.com/el-paso"
              }
            ]
          }
        },
        {
          "@type": "LocalBusiness",
          "name": "Valve Sales Supply - El Paso",
          "image": "https://valvesalessupply.com/logo.png",
          "@id": "https://valvesalessupply.com/el-paso",
          "url": "https://valvesalessupply.com/el-paso",
          "telephone": "214-854-5638",
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "El Paso",
            "addressRegion": "TX",
            "addressCountry": "US"
          },
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": 31.7619,
            "longitude": -106.4850
          },
          "areaServed": {
            "@type": "City",
            "name": "El Paso",
            "containedIn": {
              "@type": "State",
              "name": "Texas"
            }
          },
          "serviceType": ["Industrial Valve Buyers", "Surplus Equipment Buyers", "Manufacturing Equipment", "Refinery Equipment"]
        },
        {
          "@type": "FAQPage",
          "mainEntity": faqData.map(faq => ({
            "@type": "Question",
            "name": faq.question,
            "acceptedAnswer": {
              "@type": "Answer",
              "text": faq.answer
            }
          }))
        }
      ]
    };

    let script = document.querySelector('script[type="application/ld+json"]');
    if (!script) {
      script = document.createElement('script');
      script.setAttribute('type', 'application/ld+json');
      document.head.appendChild(script);
    }
    script.textContent = JSON.stringify(schemaData);

    // Cleanup function
    return () => {
      // Optional: Clean up meta tags if needed
    };
  }, []);

  const nearbyFacilities = [
    { name: 'Western Refining', type: 'Refinery', capacity: '128,000 BPD' },
    { name: 'El Paso Natural Gas', type: 'Pipeline Hub', capacity: 'Major Terminal' },
    { name: 'Manufacturing Plants', type: 'Industrial', capacity: '50+ Facilities' }
  ];

  const faqData = [
    {
      question: "Do you buy valves from El Paso refineries?",
      answer: "Yes, we purchase surplus valves, Fisher control valves, and instrumentation from El Paso refineries including Western Refining and manufacturing facilities. We provide professional equipment purchasing services for West Texas and Southwest industrial facilities."
    },
    {
      question: "What types of equipment do you buy in El Paso?",
      answer: "We buy control valves, gate valves, globe valves, ball valves, heat exchangers, pumps, compressors, safety systems, Rosemount transmitters, flow meters, pressure instruments, and controllers from El Paso industrial facilities."
    },
    {
      question: "How quickly can you respond to El Paso facilities?",
      answer: "We provide 8-10 hour response times for El Paso and West Texas facilities. Our team serves the Southwest region including El Paso, New Mexico, and West Texas industrial operations."
    },
    {
      question: "Do you purchase equipment from El Paso manufacturing plants?",
      answer: "Yes, we buy industrial equipment from El Paso's 50+ manufacturing facilities. We understand the diverse industrial base in El Paso and provide competitive pricing for process equipment and instrumentation."
    },
    {
      question: "What valve brands do you buy from El Paso facilities?",
      answer: "We purchase Fisher, Masoneilan, Flowserve, Cameron, Rosemount, Emerson, Honeywell, and other major brands from El Paso refineries, pipeline facilities, and manufacturing plants."
    },
    {
      question: "Do you serve New Mexico facilities from El Paso?",
      answer: "Yes, our El Paso service area covers West Texas and Southern New Mexico. We regularly purchase equipment from facilities in both states with fast response times and competitive pricing."
    }
  ];

  return (
    <div className="min-h-screen">
      <Header />
      
      {/* Hero Section */}
      <section className="relative pt-24 pb-16">
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url('https://public.readdy.ai/ai/img_res/59a2db33c8cede7c4a41259458729806.jpg')`
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-r from-[#1B3A5F]/90 to-[#1B3A5F]/70"></div>
        </div>
        
        <div className="relative z-10 max-w-7xl mx-auto px-6 text-white">
          <div className="max-w-4xl">
            <h1 className="text-5xl font-bold mb-6">El Paso / We Buy Valves</h1>
            <p className="text-xl text-gray-200 mb-8 leading-relaxed">
              Leading <strong>valve buyers in El Paso</strong> serving West Texas and New Mexico industrial facilities. 
              Valve Sales Supply purchases surplus valves, control systems, and instrumentation from El Paso refineries 
              and manufacturing plants at above scrap rates.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <a
                href="tel:214-854-5638"
                className="bg-white text-[#1B3A5F] px-8 py-4 rounded-full font-bold text-lg hover:bg-gray-100 transition-all duration-300 inline-flex items-center justify-center whitespace-nowrap"
              >
                <i className="ri-phone-line mr-2"></i>
                CALL 214-854-5638
              </a>
              <Link
                to="/contact"
                className="border-2 border-white text-white px-8 py-4 rounded-full font-bold text-lg hover:bg-white hover:text-[#1B3A5F] transition-all duration-300 inline-flex items-center justify-center whitespace-nowrap"
              >
                GET EL PASO QUOTE
                <i className="ri-arrow-right-line ml-2"></i>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Market Overview */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <div>
              <h2 className="text-[#1B3A5F] text-4xl font-bold mb-6">EL PASO INDUSTRIAL EQUIPMENT BUYER</h2>
              <p className="text-gray-600 text-lg mb-6 leading-relaxed">
                El Paso's strategic border location makes it a key industrial hub for West Texas and the Southwest. 
                As experienced <strong className="text-[#1B3A5F]">surplus valve buyers in El Paso</strong>, 
                we provide professional equipment purchasing services for refineries and manufacturing facilities.
              </p>
              <p className="text-gray-600 text-lg mb-8 leading-relaxed">
                We specialize in purchasing <strong className="text-[#1B3A5F]">Fisher control valves</strong>, 
                Rosemount transmitters, and complete control systems from El Paso industrial facilities.
              </p>
              
              <div className="grid md:grid-cols-3 gap-6">
                <div className="text-center">
                  <div className="text-[#1B3A5F] text-3xl font-bold">50+</div>
                  <div className="text-gray-600">Industrial Facilities</div>
                </div>
                <div className="text-center">
                  <div className="text-[#1B3A5F] text-3xl font-bold">8-10 Hrs</div>
                  <div className="text-gray-600">Response Time</div>
                </div>
                <div className="text-center">
                  <div className="text-[#1B3A5F] text-3xl font-bold">128K</div>
                  <div className="text-gray-600">BPD Capacity</div>
                </div>
              </div>
            </div>
            
            <div className="bg-[#F5F7FA] rounded-3xl p-8">
              <h3 className="text-[#1B3A5F] text-2xl font-bold mb-6">EL PASO FACILITIES</h3>
              <div className="space-y-4">
                {nearbyFacilities.map((facility, index) => (
                  <div key={index} className="bg-white rounded-lg p-4">
                    <h4 className="text-[#1B3A5F] font-bold text-lg">{facility.name}</h4>
                    <div className="flex justify-between mt-2">
                      <span className="text-gray-600 text-sm">{facility.type}</span>
                      <span className="text-[#1B3A5F] font-semibold text-sm">{facility.capacity}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Equipment Categories */}
      <section className="py-20 bg-[#F5F7FA]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-[#1B3A5F] text-4xl font-bold mb-4">SELL VALVES EL PASO TX</h2>
            <p className="text-gray-600 text-xl">Professional equipment purchasing from El Paso industrial facilities</p>
          </div>
          
          <div className="grid lg:grid-cols-3 gap-8">
            {[
              {
                title: 'Control Valves',
                equipment: ['Fisher Control Valves', 'Masoneilan Valves', 'Ball Valves', 'Gate Valves', 'Globe Valves'],
                description: 'Premium control valves from El Paso refineries'
              },
              {
                title: 'Process Equipment',
                equipment: ['Heat Exchangers', 'Pumps', 'Compressors', 'Safety Systems'],
                description: 'Industrial equipment from manufacturing facilities'
              },
              {
                title: 'Instrumentation',
                equipment: ['Rosemount Transmitters', 'Flow Meters', 'Pressure Instruments', 'Controllers'],
                description: 'Process instrumentation from West Texas facilities'
              }
            ].map((category, index) => (
              <div key={index} className="bg-white rounded-3xl p-8 hover:shadow-lg transition-all duration-300">
                <h3 className="text-[#1B3A5F] text-2xl font-bold mb-4">{category.title}</h3>
                <p className="text-gray-600 mb-6">{category.description}</p>
                
                <div className="space-y-3">
                  {category.equipment.map((item, itemIndex) => (
                    <div key={itemIndex} className="flex items-center">
                      <i className="ri-check-line text-[#1B3A5F] mr-3"></i>
                      <span className="text-gray-700">{item}</span>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Related Markets */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-[#1B3A5F] text-4xl font-bold mb-4">RELATED MARKETS</h2>
            <p className="text-gray-600 text-xl">We serve Southwest industrial centers</p>
          </div>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {[
              { city: 'San Antonio', link: '/san-antonio', state: 'TX' },
              { city: 'Albuquerque', link: '/albuquerque', state: 'NM' },
              { city: 'Dallas', link: '/dallas', state: 'TX' },
              { city: 'Houston', link: '/houston', state: 'TX' }
            ].map((market, index) => (
              <Link
                key={index}
                to={market.link}
                className="bg-[#F5F7FA] rounded-xl p-6 text-center hover:shadow-lg hover:bg-white transition-all duration-300 border-2 border-transparent hover:border-[#1B3A5F]"
              >
                <h3 className="text-[#1B3A5F] text-xl font-bold mb-2">{market.city}</h3>
                <div className="text-gray-600 text-sm mb-3">{market.state} Valve Buyers</div>
                <div className="text-[#1B3A5F] font-semibold inline-flex items-center">
                  View Details
                  <i className="ri-arrow-right-line ml-2"></i>
                </div>
              </Link>
            ))}
          </div>
          
          <div className="text-center mt-8">
            <Link
              to="/texas"
              className="text-[#1B3A5F] font-semibold hover:underline inline-flex items-center text-lg"
            >
              View All Texas Cities
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="py-20 bg-[#1B3A5F]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div className="text-white">
              <h2 className="text-4xl font-bold mb-6">EL PASO EQUIPMENT BUYER</h2>
              <p className="text-xl text-gray-200 mb-8">
                Contact Mark Driver for professional equipment purchasing services in El Paso
              </p>
              
              <div className="space-y-4">
                <div className="flex items-center">
                  <i className="ri-phone-line text-2xl mr-4"></i>
                  <div>
                    <div className="font-bold text-xl">214-854-5638</div>
                    <div className="text-gray-300">Direct Line - Mark Driver</div>
                  </div>
                </div>
                
                <div className="flex items-center">
                  <i className="ri-mail-line text-2xl mr-4"></i>
                  <div>
                    <div className="font-bold">elpaso@valvesalessupply.com</div>
                    <div className="text-gray-300">Equipment Lists & Photos</div>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="bg-white rounded-3xl p-8">
              <h3 className="text-[#1B3A5F] text-2xl font-bold mb-6">WHY CHOOSE VALVE SALES SUPPLY</h3>
              <div className="space-y-4">
                {[
                  'Above scrap rates for functional equipment',
                  'Fast 8-10 hour response in El Paso',
                  'Expert knowledge of industrial equipment',
                  'Professional turnaround coordination',
                  'Complete compliance documentation',
                  '25+ years Southwest market experience'
                ].map((benefit, index) => (
                  <div key={index} className="flex items-center">
                    <i className="ri-check-line text-[#1B3A5F] text-xl mr-3"></i>
                    <span className="text-gray-700">{benefit}</span>
                  </div>
                ))}
              </div>
              
              <div className="mt-8">
                <Link
                  to="/contact"
                  className="bg-[#1B3A5F] text-white px-8 py-4 rounded-full font-bold hover:bg-[#1B3A5F]/90 transition-all duration-300 inline-flex items-center justify-center w-full whitespace-nowrap"
                >
                  GET QUOTE TODAY
                  <i className="ri-arrow-right-line ml-2"></i>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-6">
          <h2 className="text-[#1B3A5F] text-4xl font-bold mb-12 text-center">EL PASO VALVE BUYERS FAQ</h2>
          <div className="space-y-6">
            {faqData.map((faq, index) => (
              <div key={index} className="bg-[#F5F7FA] rounded-xl p-6">
                <h3 className="text-[#1B3A5F] text-xl font-bold mb-3">{faq.question}</h3>
                <p className="text-gray-600 leading-relaxed">{faq.answer}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ElPaso;
